const hasNumber = {
  errorMessage: 'ERROR_HAS_NUMBER',
  rule: (value: any) => /[0-9]/g.test(value),
};

export default hasNumber;
